export default "__VITE_ASSET__CRpBpSXH__"